import {
  Col,
  Input,
  InputNumber,
  Row,
  Select,
  Tooltip,
} from "antd";

import { TemplateAPI } from "../../Api/TemplatesAPI";
import { ContractAPI } from "../../Api/ContractAPI";

import FormLayout from "../FormLayout/FormLayout";
import "./ExternalContract.scss";
import useExternalContract from "../../Hooks/useExternalContract/useExternalContract";
import { InfoCircleOutlined } from "@ant-design/icons";
import LastNameField from "../Fields/LastNameField/LastNameField";
import NameField from "../Fields/NameField/NameField";
import { InstitutionsAPI } from "../../Api/InstitutionsAPI";
import { PlacementAgentValues } from "../../Models";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';

const { Option } = Select;

const ExternalContract = ({
  baseURL,
  baseURLExternal,
  translations,
  clientId,
  userIdInstitution,
}: any) => {
  const templatesAPI = TemplateAPI(baseURL, clientId);
  const contractAPI = ContractAPI(baseURL, baseURLExternal, clientId);
  const institutionAPI = InstitutionsAPI(baseURL, baseURLExternal, clientId);

  const {
    loading,
    contractErrors,
    contractData,
    onChangeData,
    sendEmailConfirm,
    isAllowedAmount,
    handleChangeData,
    investorsData,
    investorsErrors,
	placementAgentData
  } = useExternalContract({
    translations,
    templatesAPI,
    contractAPI,
    institutionAPI,
	userIdInstitution,
  });

  return (
    <div className="external-contract">
        <FormLayout
          translations={translations}
          loading={loading}
          title={translations.externalContractFiller}
          subTitle={translations.completeExternalContract}
          onClick={sendEmailConfirm}
          buttonText={translations.sendEmail}
        >
          <Row gutter={[16, 16]} className="row-wtdh">
            <Col xs={24} md={12} lg={12}>
              <label className="required">
                {translations.seleccionVehiculo}
              </label>
              <Select
                className="input-field"
                value={contractData.vehicleId || undefined}
                placeholder={translations.seleccionVehiculo}
                onChange={(value: any) => onChangeData(value, "vehicleId")}
                status={contractErrors.vehicleId ? "error" : ""}
              >
                {placementAgentData?.map((x: PlacementAgentValues) => (
                  <Option value={x.vehicleId}>{x.vehicleLegalName}</Option>
                ))}
              </Select>
              <span
                className={`error ${contractErrors.vehicleId ? "show" : null}`}
              >
                {translations.seleccionVehiculo}
              </span>
            </Col>
          </Row>
          <Row gutter={[16, 0]} className="row-wtdh">
            <Col xs={12} md={6} lg={6}>
              <label className="required"> {translations.tipoPersona}</label>
              <Select
                className="input-field"
                value={contractData.idPersonType}
                onChange={(value: any) => onChangeData(value, "idPersonType")}
              >
                <Option value={2}>{translations.juridica}</Option>
                <Option value={1}>{translations.fisica}</Option>
              </Select>
            </Col>
            <Col xs={12} md={6} lg={6}>
              <label className="required"> {translations.compromiso}</label>
              <InputNumber
                className="input-field"
                name="commitment"
                value={contractData.commitment}
				disabled={!contractData.vehicleId}
                onBlur={(e: any) => isAllowedAmount(e.target.value)}
                onChange={(value: any) => onChangeData(value, "commitment")}
                status={contractErrors.commitment ? "error" : ""}
              />
              <span
                className={`error ${contractErrors.commitment ? "show" : null}`}
              >
                {translations.messageCompromiso}
              </span>
            </Col>
            <Col xs={12} md={6} lg={6}>
              <label className="required"> {translations.language}</label>
              <Select
                className="input-field"
                value={contractData.idLanguage}
                onChange={(value: any) => onChangeData(value, "idLanguage")}
              >
                <Option value={1}>{translations.spanish}</Option>
                <Option value={2}>{translations.english}</Option>
                <Option value={3}>{translations.portuguese}</Option>
              </Select>
            </Col>
            <Col xs={12} md={6} lg={6}>
              <p>
                <label className="required">
                  {translations.personasFirmantes}
                </label>
                <Tooltip
                  placement="topLeft"
                  title={translations.tootltipPersonasFirmantes}
                >
                  <InfoCircleOutlined className="tooltip" />
                </Tooltip>
              </p>
              <InputNumber
                className="input-field"
                name="commitment"
                value={contractData.numSignatories}
                onChange={(value: any) => onChangeData(value, "numSignatories")}
                min={1}
                max={4}
                step={1}
              />
            </Col>
          </Row>
          {investorsData.map((investor: any, index: number) => (
            <>
              <Row gutter={[16, 8]} className="row-wtdh" key={index}>
                <h3>
                  {translations.datosFirmante} {index + 1}
                </h3>
              </Row>
              <Row gutter={[16, 8]} className="row-wtdh" key={index}>
                <NameField
                  name={investor.name}
                  translations={translations}
                  errors={investorsErrors}
                  index={index}
                  handleChangeData={handleChangeData}
                  size="m"
                />
                <LastNameField
                  lastName={investor.lastName}
                  translations={translations}
                  errors={investorsErrors}
                  index={index}
                  handleChangeData={handleChangeData}
                  size="m"
                />
              </Row>
            </>
          ))}
          <Row gutter={[16, 8]} className="row-wtdh">
            <h3>Email</h3>
          </Row>
          <Row gutter={[16, 0]} className="row-wtdh external-email">
            <Col xs={12} md={12} lg={12}>
              <label className="required"> {translations.emailAddress}</label>
              <Input
                className="input-field"
                name="emailAddress"
                placeholder="email@email.com"
                value={contractData.emailAddress}
                onChange={(e: any) => onChangeData(e.target.value, "emailAddress")}
                status={contractErrors.emailAddress ? "error" : ""}
              />
            </Col>
            <Col xs={12} md={12} lg={12}>
              <label className="required"> {translations.emailSubject}</label>
              <Input
                className="input-field"
                name="emailSubject"
				placeholder={translations.emailSubject}
                value={contractData.emailSubject}
                onChange={(e: any) => onChangeData(e.target.value, "emailSubject")}
                status={contractErrors.emailSubject ? "error" : ""}
              />
            </Col>
            <Col xs={12} md={12} lg={12}>
              <label className="required"> {translations.fillerName}</label>
              <Input
                className="input-field"
                name="fillerName"
                placeholder={translations.fillerName}
                value={contractData.fillerName}
                onChange={(e: any) => onChangeData(e.target.value, "fillerName")}
                status={contractErrors.fillerName ? "error" : ""}
              />
            </Col>
            <Col xs={12} md={12} lg={12}>
              <label className="required"> {translations.fillerLastname}</label>
              <Input
                className="input-field"
                name="fillerLastName"
                value={contractData.fillerLastName}
				placeholder={translations.fillerLastname}
                onChange={(e: any) => onChangeData(e.target.value, "fillerLastName")}
                status={contractErrors.fillerLastName ? "error" : ""}
              />
            </Col>
            <Col xs={24} md={24} lg={24}>
              <label className="required"> {translations.emailBody}</label>
			  	<ReactQuill
					modules={{
						toolbar: [
							[{ 'header': [1, 2, false] }],
							['bold', 'italic', 'underline', 'strike', 'blockquote'],
							[{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
							['clean']
						],
					}}
					formats={[
						'header',
						'bold', 'italic', 'underline', 'strike', 'blockquote',
						'list', 'bullet', 'indent',
						'link', 'image'
					]}
					placeholder={translations.emailBody}
					value={contractData.emailBody}
					onChange={(text) => onChangeData(text, "emailBody")}
				/>
            </Col>
          </Row>
          {contractErrors.noTemplate && (
            <span
              className={`error-big ${
                contractErrors.noTemplate ? "show" : null
              }`}
            >
              {translations.errorTemplate}
            </span>
          )}
        </FormLayout>
    </div>
  );
};

export default ExternalContract;
